export const DEFAULT_SHARED_TIME_RANGE = "7d";
export const SHARED_TIME_RANGE_OPTIONS = [
    {
        value: "24h",
        label: "24h",
        dayCount: 1
    },
    {
        value: "3d",
        label: "3d",
        dayCount: 3
    },
    {
        value: "7d",
        label: "7d",
        dayCount: 7
    },
    {
        value: "30d",
        label: "30d",
        dayCount: 30
    }
];
export const SHARED_TIME_RANGE_DAY_COUNT = Object.fromEntries(SHARED_TIME_RANGE_OPTIONS.map((option)=>[
        option.value,
        option.dayCount
    ]));
export function getTimeRangeDayCount(range) {
    return SHARED_TIME_RANGE_DAY_COUNT[range];
}
export function getTimeWindowMinutes(range) {
    return getTimeRangeDayCount(range) * 24 * 60;
}
export function toUtcDateString(date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
export function getTimeRangeDateRange(range, historicalEndDate) {
    const dayCount = getTimeRangeDayCount(range);
    const now = historicalEndDate ? new Date(`${historicalEndDate.slice(0, 10)}T00:00:00Z`) : new Date();
    const endDate = toUtcDateString(now);
    if (range === "24h") {
        return {
            startDate: endDate,
            endDate,
            dayCount,
            hourCount: 24
        };
    }
    const start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    start.setUTCDate(start.getUTCDate() - (dayCount - 1));
    return {
        startDate: toUtcDateString(start),
        endDate,
        dayCount,
        hourCount: dayCount * 24
    };
}
